import styles from "./style.module.scss";
import { GQLOffers } from "@gql/types/gql";
import { translate } from "@helpers/translationObjectFormatter";
import { useQuery } from "@tanstack/react-query";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { featureListOfferValueHandler } from "@lib/sharedUtils";
import { DISCARDED_ATTRIBUTES } from "@lib/sharedUtils";
export default function OfferQuickStats({ offer }: { offer: GQLOffers }) {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const filteredAttributes = offer?.attributes?.filter(
        (el) =>
            el?.baseAttribute?.groupSlug === "quick-stats" ||
            (!el?.baseAttribute?.hidden &&
                !el?.baseAttribute?.comparison &&
                !el?.baseAttribute?.forceComparisonsDisplay &&
                !DISCARDED_ATTRIBUTES.includes(
                    el?.baseAttribute?.name as string,
                )),
    );
    const devicesList = filteredAttributes
        ?.find((attr) => attr?.baseAttribute?.name === "devices")
        ?.value?.split(",")
        .map((device) => (
            <span
                key={device}
                className={`${styles["device"]} ${styles[device]}`}
            ></span>
        ));

    return (
        <>
            {filteredAttributes && filteredAttributes.length > 0 && (
                <section className="mt-12">
                    <h2 className="font-bold lg:text-3xl lg:leading-[45px] text-2xl">
                        {translate(
                            translations,
                            "several_vendorPage_quickStats",
                        )}
                    </h2>
                    <span
                        className={`block w-full ${styles["borderStyle"]} mt-8`}
                    ></span>
                    <div className={`${styles["mainContainer"]}`}>
                        {filteredAttributes?.map((el, index) => (
                            <div key={index}>
                                {el?.baseAttribute?.name === "devices" &&
                                devicesList &&
                                devicesList.length ? (
                                    <>
                                        <div>
                                            {translate(
                                                translations,
                                                "several_offerPage-DevicesName",
                                            )}
                                        </div>
                                        <div>{devicesList}</div>
                                    </>
                                ) : (
                                    <>
                                        <div>{el?.baseAttribute?.name}</div>
                                        <div>
                                            {featureListOfferValueHandler(
                                                el?.value as string,
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                </section>
            )}
        </>
    );
}
